import { TableStyles } from "react-data-table-component";

// Single source of truth for react-data-table-component typography so every table
// across the app shares the same header and cell fonts/weights (aligned with the
// theme's body2/subtitle scale). Applied via the `customStyles` prop. Density
// (dense vs normal) is left to each table's own prop.
export const tableCustomStyles: TableStyles = {
  headCells: {
    style: {
      fontSize: "0.8125rem", // 13px
      fontWeight: 600,
    },
  },
  cells: {
    style: {
      fontSize: "0.875rem", // 14px — matches body2
    },
  },
  // No divider line above the pagination bar (it renders on top for these tables).
  pagination: {
    style: {
      borderTopWidth: 0,
    },
  },
};
